var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "container" }, [
    _c("div", { staticClass: "events-sidebar row" }, [
      _c(
        "div",
        { staticClass: "event-filter col-md-6 col-lg-3" },
        [
          _c("date-picker", {
            staticClass: "form-input event-filter-dropdown",
            attrs: { format: "MMMM D, YYYY", options: { firstDay: 1 } },
            on: {
              input: function ($event) {
                return _vm.selectedDate($event)
              },
            },
            model: {
              value: _vm.date,
              callback: function ($$v) {
                _vm.date = $$v
              },
              expression: "date",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "event-filter filter-btn d-flex justify-content-end d-lg-none col-md-6",
          class: { open: _vm.showFilters },
          on: {
            click: function ($event) {
              _vm.showFilters = !_vm.showFilters
            },
          },
        },
        [_vm._m(0)]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "event-filter-dropdown mobile-filters-container offset-md-6 col-md-6 offset-lg-0 col-lg-9 d-lg-flex",
          class: { open: _vm.showFilters },
        },
        [
          _c(
            "div",
            { staticClass: "faculty-filter dropdown-input col-12 col-lg-4" },
            [
              _c("h3", [_vm._v("Event Categories")]),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "event-filter-dropdown",
                  attrs: {
                    type: "button",
                    "data-toggle": "dropdown",
                    "aria-haspopup": "true",
                    "aria-expanded": "true",
                  },
                },
                [
                  _vm._v(
                    "\n          " +
                      _vm._s(
                        _vm.activeCategory
                          ? _vm.activeCategory.name
                          : "All Categories"
                      ) +
                      "\n          "
                  ),
                  _c("chevron-icon"),
                  _vm._v(" "),
                  _c("div", { staticClass: "sr-only" }, [_vm._v("Dropdown")]),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "ul",
                { staticClass: "dropdown-menu" },
                [
                  _c("li", { staticClass: "active" }, [
                    _c(
                      "a",
                      {
                        attrs: { href: "#" },
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                            return (() => _vm.reset("categories")).apply(
                              null,
                              arguments
                            )
                          },
                        },
                      },
                      [_vm._v("All Categories")]
                    ),
                  ]),
                  _vm._v(" "),
                  _vm._l(
                    _vm.categories.filter(
                      (cat) => cat.slug !== "student-recital"
                    ),
                    function (item, index) {
                      return _c("event-category", {
                        key: index,
                        attrs: { item: item, index: index, route: "cat" },
                        on: { chooseCategory: _vm.onChooseCategory },
                      })
                    }
                  ),
                ],
                2
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "faculty-filter dropdown-input col-12 col-lg-4" },
            [
              _c("h3", [_vm._v("Special Programs")]),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "event-filter-dropdown",
                  attrs: {
                    type: "button",
                    "data-toggle": "dropdown",
                    "aria-haspopup": "true",
                    "aria-expanded": "true",
                  },
                },
                [
                  _vm._v(
                    "\n          " +
                      _vm._s(
                        _vm.activeSerie
                          ? _vm.activeSerie.name
                          : "All Special Programs"
                      ) +
                      "\n          "
                  ),
                  _c("chevron-icon"),
                  _vm._v(" "),
                  _c("div", { staticClass: "sr-only" }, [_vm._v("Dropdown")]),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "ul",
                { staticClass: "dropdown-menu" },
                [
                  _c("li", { staticClass: "active" }, [
                    _c(
                      "a",
                      {
                        attrs: { href: "#" },
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                            return (() => _vm.reset("series")).apply(
                              null,
                              arguments
                            )
                          },
                        },
                      },
                      [_vm._v("All Special Programs")]
                    ),
                  ]),
                  _vm._v(" "),
                  _vm._l(_vm.series, function (item, index) {
                    return _c("event-category", {
                      key: index,
                      attrs: {
                        item: item,
                        index: index,
                        route: "special-program",
                      },
                      on: { chooseCategory: _vm.onChooseSerie },
                    })
                  }),
                ],
                2
              ),
            ]
          ),
          _vm._v(" "),
          _vm.eventsSubscriptionLink
            ? _c(
                "div",
                {
                  staticClass:
                    "event-filter calendar-subscription col-12 col-lg-4 d-flex justify-content-center align-items-start",
                },
                [
                  _c(
                    "a",
                    {
                      staticClass: "cta pill-cta yellow",
                      attrs: { href: _vm.eventsSubscriptionLink },
                    },
                    [
                      _c("span", [
                        _vm._v(
                          "\n            Subscribe to Calendar\n          "
                        ),
                      ]),
                    ]
                  ),
                ]
              )
            : _vm._e(),
        ]
      ),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "events-content" },
      [
        _c(
          "transition-group",
          {
            staticClass: "events-list row",
            attrs: { name: "fade", tag: "div" },
          },
          _vm._l(_vm.events, function (event) {
            return _c("event-card", { key: event.id, attrs: { event: event } })
          }),
          1
        ),
        _vm._v(" "),
        _vm.loading
          ? _c("div", { staticClass: "loader" }, [_vm._v("Loading Events...")])
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "pagination" }, [
          _vm.curPage > 1
            ? _c(
                "button",
                {
                  staticClass: "prev-arrow",
                  on: {
                    click: () => {
                      this.curPage = this.curPage - 1
                      _vm.appendItems()
                    },
                  },
                },
                [
                  _c("span", { staticClass: "icon" }, [_c("arrow-icon")], 1),
                  _vm._v("\n        Previous Events\n      "),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          !_vm.noMoreItems
            ? _c(
                "button",
                {
                  staticClass: "next-arrow",
                  on: {
                    click: () => {
                      this.curPage = this.curPage + 1
                      _vm.appendItems()
                    },
                  },
                },
                [
                  _vm._v("\n        Next Events\n        "),
                  _c("span", { staticClass: "icon" }, [_c("arrow-icon")], 1),
                ]
              )
            : _vm._e(),
        ]),
      ],
      1
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", [
      _vm._v("\n        Filter\n        "),
      _c("img", {
        staticClass: "filter-icon svg",
        attrs: {
          src: "/app/themes/ucla/resources/assets/images/filter.svg",
          width: "16px",
          height: "16px",
          alt: "filter",
        },
      }),
      _vm._v(" "),
      _c("img", {
        staticClass: "filter-icon-selected svg",
        attrs: {
          src: "/app/themes/ucla/resources/assets/images/filter-selected.svg",
          width: "16px",
          height: "16px",
          alt: "selected filter",
        },
      }),
      _vm._v(" "),
      _c("div", { staticClass: "sr-only" }, [_vm._v("Filter")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }


// WEBPACK FOOTER //
// ./scripts/vue/EventsDirectory.vue